module.exports = __webpack_public_path__ + "static/img/done.7a730104.svg";